import { useEffect } from "react";
import { useParams } from "react-router-dom";

export default function PublicCardRedirect() {
    const { slug } = useParams();
    useEffect(() => {
        const base = process.env.REACT_APP_BACKEND_URL || "";
        window.location.replace(`${base}/api/public/card/${encodeURIComponent(slug)}`);
    }, [slug]);
    return (
        <div className="min-h-screen flex items-center justify-center text-[#17212B]/60" data-testid="card-redirect">
            Loading visiting card…
        </div>
    );
}
